import type { CSSProperties } from "react";
import type { LetterState } from "@mk/shared";
import { messages } from "../i18n/index.ts";

interface TileProps {
  letter?: string;
  state?: LetterState;
  /** Satırdaki sıra — kutucukların sırayla çevrilmesi için gecikme verir. */
  index: number;
  /** Aktif satırda oyuncunun seçtiği kutucuk. */
  selected?: boolean;
  /** Verilirse kutucuk basılabilir olur (yalnızca aktif satır). */
  onSelect?: (index: number) => void;
  /** Sunucunun kapattığı kullanılmayacak tahmin satırı. */
  locked?: boolean;
}

export function Tile({ letter, state, index, selected, onSelect, locked = false }: TileProps) {
  const shared = {
    className: "tile",
    "data-filled": letter ? "true" : undefined,
    "data-state": state,
    "data-selected": selected ? "true" : undefined,
    "data-locked": locked ? "true" : undefined,
    style: { "--flip-delay": `${index * 180}ms` } as CSSProperties,
  };

  if (locked) {
    return <div {...shared} role="gridcell" aria-label={messages.board.locked} />;
  }

  if (!onSelect) {
    return <div {...shared}>{letter ?? ""}</div>;
  }

  return (
    <button
      {...shared}
      type="button"
      aria-pressed={selected}
      aria-label={
        letter
          ? messages.board.letter(index + 1, letter)
          : messages.board.emptyLetter(index + 1)
      }
      onClick={() => onSelect(index)}
    >
      {letter ?? ""}
    </button>
  );
}
